<template>
  <button
    ref="nextButton"
    class="w-full mt-6 shadow-green px-10 py-3 border border-transparent text-sm uppercase tracking-wider leading-normal font-bold rounded-md text-white bg-green-300 hover:bg-indigo-400 focus:outline-none border-none focus:shadow-outline-indigo active:bg-indigo-400"
    @click="onButtonClick()"
  >Järgmine</button>
</template>

<script>
import { gsap } from "gsap";

export default {
  name: "NextButton",
  props: ["value"],
  data: () => ({
    steps: {
      "calculator-page-style": "calculator-page-structure",
      "calculator-page-structure": "calculator-additional",
      "calculator-additional": "calculator-google",
      "calculator-google": "calculator-end",
    },
  }),
  methods: {
    onButtonClick() {
      this.$emit("onNext", this.steps[this.value]);
    },
  },
  watch: {
    value(newValue) {
      if (newValue === "calculator-end")
        gsap.to(this.$refs["nextButton"], { autoAlpha: 0, ease: "slow" });
    },
  },
};
</script>

<style scoped>
</style>
